/**
 * Entity id spaces. Every peer in a zone must agree on the ids of replicated
 * actors, so ids are partitioned:
 * - [1, SHARED_ID_LIMIT): allocated by the zone host (monsters, helpers).
 * - [LOCAL_ID_BASE, PLAYER_ID_BASE): peer-local actors that are never
 *   replicated (NPCs).
 * - [PLAYER_ID_BASE, …): player characters, derived from the owning peer's id
 *   so every peer computes the same id without coordination.
 */
export const SHARED_ID_LIMIT = 1_000_000;
export const LOCAL_ID_BASE = 1_000_000;
export const PLAYER_ID_BASE = 2_000_000;

/** Deterministic actor id of a peer's player character (FNV-1a of the peer id). */
export function playerNetId(peer: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < peer.length; i++) {
    h ^= peer.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return PLAYER_ID_BASE + ((h >>> 0) % 100_000_000);
}
